import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ProductImage from "../../category/listings/ProductImage";
import { SALE_STATES } from "../../../core/blocks/AdPlan/constants";
import type { ReactNode } from "react";
import type { TSelector } from "../../../../i18n/types";

interface Props {
  product: {
    id: string;
    sku: string;
    sales_state: string;
    product_title: string;
  };
  showSalesLabelBadge?: boolean;
  salesStateArray?: { value: string; label: TSelector }[];
  additionalBadges?: ReactNode;
  selectedProduct?: string | null;
  setSelectedProduct?: (value: string) => void;
}

const ProductCell = ({
  product,
  showSalesLabelBadge,
  // Below allows for override to show more or less sales state badge options
  salesStateArray = [SALE_STATES.BEST_SELLER!, SALE_STATES.CLEARANCE!, SALE_STATES.NEW_PRODUCT!],
  additionalBadges = null,
  selectedProduct,
  setSelectedProduct,
}: Props) => {
  const { t } = useTranslation(["merchandising", "advertising"]);
  const { id, sku, sales_state, product_title } = product;
  const salesLabelSelector = salesStateArray.find((s) => s.value === sales_state)?.label;
  const translatedSalesLabel = salesLabelSelector ? t(salesLabelSelector) : undefined;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        paddingRight: "3rem",
      }}
    >
      <div style={{ float: "left" }}>
        <ProductImage divId={"parentProductImage" + id} id={id} width="50px" height="50px" />
      </div>{" "}
      <div style={{ float: "left", width: "100%" }}>
        <div key={"parentProductAsin" + id}>
          <span
            style={{
              marginLeft: "1.5rem",
              fontSize: "15px",
              textAlign: "center",
              fontWeight: id === selectedProduct ? "700" : "500",
              cursor: "pointer",
              float: "left",
              color: typeof setSelectedProduct === "function" ? "#d91266" : "inherit",
              textDecoration: typeof setSelectedProduct === "function" ? "underline" : "none",
            }}
            onClick={() => setSelectedProduct && setSelectedProduct(id)}
          >
            {sku}
          </span>
        </div>
        <div
          style={{
            float: "left",
            marginLeft: "1.5rem",
            fontSize: "1.25rem",
            width: "100%",
            textAlign: "left",
            whiteSpace: "break-spaces",
            fontWeight: 400,
            height: "100%",
          }}
        >
          {product_title}
        </div>
        {((showSalesLabelBadge && translatedSalesLabel) || additionalBadges) && (
          <div
            style={{
              float: "left",
              marginLeft: "1.5rem",
              fontSize: "1.25rem",
              width: "100%",
              textAlign: "left",
              paddingTop: "1rem",
            }}
          >
            {showSalesLabelBadge && translatedSalesLabel && (
              <Badge className="badge-primary" pill>
                {translatedSalesLabel}
              </Badge>
            )}
            {additionalBadges}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCell;
